import React from "react";
import { PitchPlayer } from "./PitchPlayer";
import { ShirtKit } from "./ShirtKit";
import { pkey } from "./fplUtils";

const line = "rgba(255,255,255,0.55)";

const Markings = ({ compact }) => {
  const b = compact ? "border" : "border-2";
  return (
    <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
      <div className={`absolute inset-x-[4%] top-[3%] bottom-[2%] ${b}`} style={{ borderColor: line }} />
      <div className={`absolute left-1/2 top-[3%] -translate-x-1/2 -translate-y-1/2 w-[26%] aspect-square rounded-full ${b}`} style={{ borderColor: line }} />
      <div className={`absolute left-1/2 bottom-[2%] -translate-x-1/2 w-[58%] h-[17%] ${b} border-b-0`} style={{ borderColor: line }} />
      <div className={`absolute left-1/2 bottom-[2%] -translate-x-1/2 w-[28%] h-[7%] ${b} border-b-0`} style={{ borderColor: line }} />
    </div>
  );
};

// FPL "Pick Team" style pitch: striped grass, shirts with name tags. `points` swaps rating tag for season points.
export const FplPitch = ({ xi = [], armbands = {}, pendingPlayer, slotAccepts, onPlace, onCaptain, points, star, compact = false, testid = "fpl-pitch", square = true }) => (
  <div data-testid={testid} className={`${compact ? "rounded-md" : "rounded-t-xl shadow-[0_10px_30px_rgba(0,0,0,0.35)]"} overflow-hidden`}>
    <div
      className={`relative w-full aspect-[4/5] ${square && !compact ? "sm:aspect-[1/1]" : ""}`}
      style={{ background: "repeating-linear-gradient(180deg,#0b9a4c 0 9%,#09893f 9% 18%)" }}
    >
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 40%, rgba(255,255,255,0.12), transparent 65%)" }} />
      <Markings compact={compact} />
      {xi.map((s) => {
        const highlight = !compact && !s.player && pendingPlayer && slotAccepts && slotAccepts(s, pendingPlayer);
        return (
          <div
            key={s.id}
            className="absolute -translate-x-1/2 -translate-y-1/2 z-10"
            style={{ left: `${s.x}%`, top: `${compact ? s.y : s.y - 3}%` }}
          >
            {compact ? (
              <div className="text-white">
                <ShirtKit short={s.player?.short} color={s.player?.color} isGK={s.cat === "GK"} empty={!s.player} className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
              </div>
            ) : (
              <PitchPlayer
                slot={s}
                armband={s.player ? armbands[pkey(s.player)] : null}
                highlight={highlight}
                points={s.player && points ? points[pkey(s.player)] : undefined}
                star={!!s.player && star === pkey(s.player)}
                onCaptain={onCaptain && s.player ? () => onCaptain(pkey(s.player)) : undefined}
                onPlace={() => onPlace(pendingPlayer, s.id)}
              />
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default FplPitch;
